import {PersonSummaryModel} from '../entity/personSummary.model';
import {HttpModelConverter} from '../../../core/converter/httpModel.converter';
import {ValueAndLabelConverter} from '../../../common/converter/ValueAndLabel.converter';
import {PhoneConverter} from '../../../common/phone/entity/converter/phone.converter';
import {Injectable} from '@angular/core';
import {DateConverter} from '../../../common/converter/date.converter';

@Injectable({
    providedIn: 'root'
})
export class PersonSummaryConverter extends HttpModelConverter<PersonSummaryModel>{

    protected createInstance(): PersonSummaryModel {
        return new PersonSummaryModel();
    }

    protected enrichObject(result: PersonSummaryModel, src: PersonSummaryModel) {
        result.civility = new ValueAndLabelConverter().convert(src.civility);
        result.gender = new ValueAndLabelConverter().convert(src.gender);
        result.phone = new PhoneConverter().convert(src.phone);
        result.officePhone = new PhoneConverter().convert(src.officePhone);
        result.mobilePhone = new PhoneConverter().convert(src.mobilePhone);
        result.birthDate = new DateConverter().convert(src.birthDate);
    }
}
